import { Component, EventEmitter, Input, Output } from '@angular/core';

type SisButtonVariant = 'primary' | 'secondary' | 'ghost';
type SisButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-sis-button',
  templateUrl: './sis-button.component.html',
  styleUrls: ['./sis-button.component.css'],
  standalone: false
})
export class SisButtonComponent {
  @Input() variant: SisButtonVariant = 'primary';
  @Input() type: SisButtonType = 'button';
  @Input() disabled = false;
  @Input() block = false;
  @Input() ariaLabel: string | null = null;

  @Output() pressed = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.pressed.emit(event);
  }
}
